import { useCallback, useMemo } from "react";

import { Form, Input, Select } from "antd";

import { RVFormFloatingLabelWrap, BADGE_STATUS, RVLink, RVFormItem, RVStatusSelectOption } from "@regal-voice/ui";
import { useOrchestrationPathing } from "Pages/orchestration/useOrchestrationPathing";

import { CreateEmailTaskFormItemKeys } from "../constants";

const DEMO_OPTIONS = [
    {
        name: "At Risk Email (ID# 12415)",
        state: "active",
        id: "1",
    },
];
const REQUIRED_RULE = [
    {
        required: true,
        message: "Email Task selection is required.",
    },
];

const ID_LABEL = "Email Task Name";
const LINK_TEXT = "Edit Email Campaign";

export function EmailTaskFormItems(): JSX.Element {
    const form = Form.useFormInstance();
    const { campaignsBasePath } = useOrchestrationPathing();

    const aiOptions = useMemo(() => {
        return DEMO_OPTIONS?.map((demo) => {
            const { name, state } = demo;
            const badgeStatus = state === "draft" ? BADGE_STATUS.PENDING : BADGE_STATUS.ACTIVE;
            return {
                label: <RVStatusSelectOption name={name} badgeStatus={badgeStatus} badgeContent={state} />,
                value: demo.id,
            };
        });
    }, []);

    const handleSMSSelect = useCallback(
        (value: string) => {
            const fileName = DEMO_OPTIONS?.find((file) => file.id === value)?.name;
            form.setFieldValue(CreateEmailTaskFormItemKeys.createEmailTaskName, fileName);
        },
        [form]
    );

    return (
        <>
            <RVFormFloatingLabelWrap
                showFormLabel
                name={CreateEmailTaskFormItemKeys.createEmailTaskID}
                label={ID_LABEL}
                rules={REQUIRED_RULE}
            >
                <Select options={aiOptions} onChange={handleSMSSelect} />
            </RVFormFloatingLabelWrap>
            <RVFormItem name={CreateEmailTaskFormItemKeys.createEmailTaskName} hidden>
                <Input />
            </RVFormItem>

            <RVLink to={campaignsBasePath} text={LINK_TEXT} />
        </>
    );
}
